// extracted by mini-css-extract-plugin
export default {"screen":"screenbase_screen__ArynL","screenBody":"screenbase_screenBody__-SOoA","note":"screenbase_note__OHSgT"};